<p-toast></p-toast>
<div class="app-verification-container mt-2">
    <div class="card">
        <div class="grid d-flex align-items-center justify-content-center">
            <div class="col-12 md:col-4">
                <button pButton pRipple label="{{'ADD_TARGET'| translate}}" icon="pi pi-plus"
                    class="p-button-success mr-2" (click)="addTarget()"></button>
            </div>
        </div>
        <div class="card dashboardTable">
            <p-table #miTable [value]="miData" [rows]="10" [paginator]="true" [globalFilterFields]="[
                'ProgramName',
                'ProgramType',
                'UserType',
                'District',
                'Caste',
                'Area',
                'Amount',
                'FarmersToBeBenefitted',
                'StartDate',
                'Enddate',
                'Active',
                'Status',
                'FinYear',
                'TotalApp',
                'Block',
                'AchievedArea',
                'AchievedApplication',
                'LastAppDate',
                'FarmersToBeBenefitted'
                    ]" responsiveLayout="scroll" [rowHover]="true" dataKey="appid"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [loading]="loadingMI" styleClass="p-datatable-gridlines"
                [tableStyle]="{'max-width': '80rem'}">
                <ng-template pTemplate="caption">
                    <div class="grid d-flex align-items-center justify-content-end"
                        [ngStyle]="{'color': 'black', 'background-color': 'white'}">
                        <!-- Left side -->
                        <div class="col-12 md:col-4">
                            <h5>MI Target</h5>
                            <!-- <button pButton pRipple label="{{'ADD_TARGET'| translate}}" icon="pi pi-plus"
                                class="p-button-success mr-2" (click)="addTarget()"></button> -->
                        </div>
                        <!-- Middle section for buttons -->
                        <div class="col-0 md:col-4 d-flex justify-content-center">
                            <button *ngIf="miData.length>0" (click)="menu.toggle($event)" pButton pRipple
                                label="{{'' | translate}}" icon="pi pi-download" class="p-button-help"></button>
                            <p-menu #menu [popup]="true" [model]="menuItemsMI"></p-menu>
                            <button (click)="refreshMITable()" pButton pRipple label="{{''| translate}}"
                                icon="pi pi-refresh" class="p-button-info ml-3"></button>
                        </div>
                        <!-- Right side for search -->
                        <div class="col-12 md:col-4 gap-3 d-flex align-items-center justify-content-end">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="miTable.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="{{'SEARCH'| translate}}" />
                            </span>
                        </div>
                    </div>
                </ng-template>

                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th>{{'S_NO'| translate}}</th> -->
                        <th>{{'FINANCIAL_YEAR'| translate}}</th>
                        <th>{{'PROGRAMME_TYPE'| translate}}
                            <p-columnFilter type="text" field="ProgramType" display="menu"></p-columnFilter>
                        </th>
                        <th>{{'PROGRAMME_NAME'| translate}}</th>
                        <th>{{'USER_TYPE'| translate}}
                            <p-columnFilter type="text" field="UserType" display="menu"></p-columnFilter>
                        </th>
                        <th>{{'DISTRICT/BLOCK/VILLAGE'| translate}}</th>
                        <th>{{'CASTE'| translate}}</th>
                        <th>{{'AREA_IN'| translate}}</th>
                        <!-- <th>{{'NO_OF_APPLICATIONS'| translate}}</th> -->
                        <!-- <th>{{'AMOUNT'| translate}}</th> -->
                        <th>{{'TOTAL_ARCHIEVED_AREA'| translate}}</th>
                        <th>{{'TOTAL_ARCHIEVED_APP'| translate}}</th>
                        <th>{{'LAST_APP_RECIEVED_ON'| translate}}</th>
                        <th>{{'TOTAL_APP'| translate}}</th>
                        <!-- <th>{{'FARMER_TO_BE_BENEFITTEDD'| translate}}</th> -->
                        <th>{{'START_DATE'| translate}}</th>
                        <th>{{'END_DATE'| translate}}</th>
                        <th>{{'STATUS'| translate}}
                            <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter>
                        </th>
                        <th>{{'ACTION'| translate}}</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-val let-ri="rowIndex">
                    <!-- <tr class="body-section"> -->
                    <tr class="body-section"
                        [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(val)}">
                        <!-- <td>{{ ri + 1 }}</td> -->
                        <td>{{val?.FinYear}}</td>
                        <td>{{val?.ProgramType == 'Pond' ? 'Tank' : val?.ProgramType}}</td>
                        <td>{{val?.ProgramName}}</td>
                        <td>{{val?.UserType}}</td>
                        <td>{{val?.District}}</td>
                        <td>{{val?.Caste}}</td>
                        <td>{{val?.Area}}</td>
                        <!-- <td>{{val?.FarmersToBeBenefitted}}</td> -->
                        <!-- <td>{{val?.Amount | currency: 'INR'}}</td> -->
                        <td>{{val?.AchievedArea}}</td>
                        <td>{{val?.AchievedApplication}}</td>
                        <td>{{val?.LastAppDate}}</td>
                        <td>{{val?.TotalApp}}</td>
                        <!-- <td>{{val?.FarmersToBeBenefitted}}</td> -->
                        <td>{{val?.startDate | date:'mediumDate'}}</td>
                        <td>{{val?.endDate | date:'mediumDate'}}</td>
                        <!-- <td>
                                <button pButton pRipple type="button" label="Assign" (click)="onClickAssign(val)"
                                    class="p-button-rounded p-button-text p-button-success mr-2">
                                </button>
                                <button pButton pRipple type="button" label="Re-Assign" (click)="onClickReAssign(val)"
                                    class="p-button-rounded p-button-text p-button-danger">
                                </button>
                            </td> -->
                        <!-- <td>
                                <button *ngIf="val?.Active == 1" pButton pRipple type="button"
                                    class="p-button-rounded p-button-success"
                                    label="{{ val?.Active }}"></button>
                                <button *ngIf="val?.Active == 0" pButton pRipple type="button"
                                    class="p-button-rounded p-button-danger"
                                    label="{{ val?.Active }}"></button>
                            </td> -->
                        <td>{{val?.Status}}</td>
                        <td>
                            <button *ngIf="val?.Active == 1" pButton pRipple type="button" pTooltip=""
                                (click)="updateStatus(val)" icon="pi pi-pencil" class="p-button-rounded"></button>
                        </td>
                        <!-- <td>
                                <button *ngIf="val?.Active == 0" pButton pRipple type="button"
                                    pTooltip="" (click)="updateAction(val)" icon="pi pi-pencil"
                                    class="p-button-rounded"></button>
                            </td> -->
                    </tr>
                </ng-template>

                <ng-template pTemplate="summary">
                    <div class="flex  justify-content-between flex-column ">
                        <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{miData ?
                            miData.length : 0 }} {{'RECORDS_ADDED'| translate}}
                        </p>
                        <div class="flex  justify-content-between flex-column ">
                            <div class="flex">
                                <div
                                    style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                </div>{{'ACTIVE' | translate}}
                            </div>
                            <!-- <div class="flex"><div style="background-color:#ffffc5 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING' | translate}}</div>
                                <div class="flex"><div style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'RETUREN_PROCESS' | translate}}</div> -->
                            <div class="flex">
                                <div
                                    style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                </div>{{'INACTIVE' | translate}}
                            </div>
                        </div>
                    </div>
                </ng-template>

            </p-table>
        </div>

        <div class="card dashboardTable">
            <p-table #pondTable [value]="pondData" [rows]="10" [paginator]="true" [globalFilterFields]="[
                'ProgramName',
                'ProgramType',
                'UserType',
                'District',
                'Caste',
                'Area',
                'Amount',
                'FarmersToBeBenefitted',
                'StartDate',
                'Enddate',
                'Active',
                'Status',
                'FinYear',
                'TotalApp',
                'Block',
                'AchievedArea',
                'AchievedApplication',
                'LastAppDate',
                'FarmersToBeBenefitted'
                    ]" responsiveLayout="scroll" [rowHover]="true" dataKey="appid"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [loading]="loadingPond" styleClass="p-datatable-gridlines"
                [tableStyle]="{'max-width': '80rem'}">
                <ng-template pTemplate="caption">
                    <div class="grid d-flex align-items-center justify-content-end"
                        [ngStyle]="{'color': 'black', 'background-color': 'white'}">
                        <!-- Left side -->
                        <div class="col-12 md:col-4">
                            <h5>Pond Target</h5>
                            <!-- <button pButton pRipple label="{{'ADD_TARGET'| translate}}" icon="pi pi-plus"
                                class="p-button-success mr-2" (click)="addTarget()"></button> -->
                        </div>
                        <!-- Middle section for buttons -->
                        <div class="col-0 md:col-4 d-flex justify-content-center">
                            <button *ngIf="pondData.length>0" (click)="menu.toggle($event)" pButton pRipple
                                label="{{'' | translate}}" icon="pi pi-download" class="p-button-help"></button>
                            <p-menu #menu [popup]="true" [model]="menuItemsPond"></p-menu>
                            <button (click)="refreshPondTable()" pButton pRipple label="{{''| translate}}"
                                icon="pi pi-refresh" class="p-button-info ml-3"></button>
                        </div>
                        <!-- Right side for search -->
                        <div class="col-12 md:col-4 gap-3 d-flex align-items-center justify-content-end">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="pondTable.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="{{'SEARCH'| translate}}" />
                            </span>
                        </div>
                    </div>
                </ng-template>

                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th>{{'S_NO'| translate}}</th> -->
                        <th>{{'FINANCIAL_YEAR'| translate}}</th>
                        <th>{{'PROGRAMME_TYPE'| translate}}
                            <p-columnFilter type="text" field="ProgramType" display="menu"></p-columnFilter>
                        </th>
                        <th>{{'PROGRAMME_NAME'| translate}}</th>
                        <th>{{'USER_TYPE'| translate}}
                            <p-columnFilter type="text" field="UserType" display="menu"></p-columnFilter>
                        </th>
                        <th>{{'DISTRICT/BLOCK/VILLAGE'| translate}}</th>
                        <th>{{'CASTE'| translate}}</th>
                        <!-- <th>{{'AREA_IN'| translate}}</th> -->
                        <th>{{'NO_OF_APPLICATIONS'| translate}}</th>
                        <!-- <th>{{'AMOUNT'| translate}}</th> -->
                        <th>{{'TOTAL_ARCHIEVED_AREA'| translate}}</th>
                        <th>{{'TOTAL_ARCHIEVED_APP'| translate}}</th>
                        <th>{{'LAST_APP_RECIEVED_ON'| translate}}</th>
                        <th>{{'TOTAL_APP'| translate}}</th>
                        <!-- <th>{{'FARMER_TO_BE_BENEFITTEDD'| translate}}</th> -->
                        <th>{{'START_DATE'| translate}}</th>
                        <th>{{'END_DATE'| translate}}</th>
                        <th>{{'STATUS'| translate}}
                            <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter>
                        </th>
                        <th>{{'ACTION'| translate}}</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-val let-ri="rowIndex">
                    <!-- <tr class="body-section"> -->
                    <tr class="body-section"
                        [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(val)}">
                        <!-- <td>{{ ri + 1 }}</td> -->
                        <td>{{val?.FinYear}}</td>
                        <td>{{val?.ProgramType == 'Pond' ? 'Tank' : val?.ProgramType}}</td>
                        <td>{{val?.ProgramName}}</td>
                        <td>{{val?.UserType}}</td>
                        <td>{{val?.District}}</td>
                        <td>{{val?.Caste}}</td>
                        <!-- <td>{{val?.Area}}</td> -->
                        <td>{{val?.FarmersToBeBenefitted}}</td>
                        <!-- <td>{{val?.Amount | currency: 'INR'}}</td> -->
                        <td>{{val?.AchievedArea}}</td>
                        <td>{{val?.AchievedApplication}}</td>
                        <td>{{val?.LastAppDate}}</td>
                        <td>{{val?.TotalApp}}</td>
                        <!-- <td>{{val?.FarmersToBeBenefitted}}</td> -->
                        <td>{{val?.startDate | date:'mediumDate'}}</td>
                        <td>{{val?.endDate | date:'mediumDate'}}</td>
                        <!-- <td>
                                <button pButton pRipple type="button" label="Assign" (click)="onClickAssign(val)"
                                    class="p-button-rounded p-button-text p-button-success mr-2">
                                </button>
                                <button pButton pRipple type="button" label="Re-Assign" (click)="onClickReAssign(val)"
                                    class="p-button-rounded p-button-text p-button-danger">
                                </button>
                            </td> -->
                        <!-- <td>
                                <button *ngIf="val?.Active == 1" pButton pRipple type="button"
                                    class="p-button-rounded p-button-success"
                                    label="{{ val?.Active }}"></button>
                                <button *ngIf="val?.Active == 0" pButton pRipple type="button"
                                    class="p-button-rounded p-button-danger"
                                    label="{{ val?.Active }}"></button>
                            </td> -->
                        <td>{{val?.Status}}</td>
                        <td>
                            <button *ngIf="val?.Active == 1" pButton pRipple type="button" pTooltip=""
                                (click)="updateStatus(val)" icon="pi pi-pencil" class="p-button-rounded"></button>
                        </td>
                        <!-- <td>
                                <button *ngIf="val?.Active == 0" pButton pRipple type="button"
                                    pTooltip="" (click)="updateAction(val)" icon="pi pi-pencil"
                                    class="p-button-rounded"></button>
                            </td> -->
                    </tr>
                </ng-template>

                <ng-template pTemplate="summary">
                    <div class="flex  justify-content-between flex-column ">
                        <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{pondData ?
                            pondData.length : 0 }} {{'RECORDS_ADDED'| translate}}
                        </p>
                        <div class="flex  justify-content-between flex-column ">
                            <div class="flex">
                                <div
                                    style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                </div>{{'ACTIVE' | translate}}
                            </div>
                            <!-- <div class="flex"><div style="background-color:#ffffc5 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING' | translate}}</div>
                                <div class="flex"><div style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'RETUREN_PROCESS' | translate}}</div> -->
                            <div class="flex">
                                <div
                                    style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                </div>{{'INACTIVE' | translate}}
                            </div>
                        </div>
                    </div>
                </ng-template>

            </p-table>
        </div>
    </div>
    <!-- </p-card> -->
</div>

<p-dialog [(visible)]="showDialogToInsertTarget" (onHide)="hideDialog()" [style]="{width: '90%', height: '450px'}"
    header="{{ 'ADD_TARGET' | translate}}" [modal]="true" [baseZIndex]="-100" styleClass="p-fluid">
    <ng-template pTemplate="content">
        <form [formGroup]="insertStatusForm">
            <div class="p-fluid p-formgrid grid add-estimate-card">
                <div class="field col-12 md:col-2">
                    <label htmlFor="component">{{'CASTE/CATEGORY'| translate}}</label>
                    <p-dropdown [options]="casteList" appendTo="body" formControlName="caste"
                        placeholder="{{'Select Caste/ Category'| translate}}" optionLabel="label"
                        [showClear]="false"></p-dropdown>
                    <div *ngIf="isSubmitted && insertStatusFormControls.caste.errors" class="invalid-feedback">
                        <div *ngIf="insertStatusFormControls.caste.errors.required">{{'CASTE_IS_REQUIRED' | translate}}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-2">
                    <label htmlFor="component">{{'ATAL_BHUJAL_SCHEME_ALL'| translate}}</label>
                    <p-dropdown [options]="atalBhujalSchemeList" appendTo="body" formControlName="abyUser"
                        placeholder="{{'Select Atal Bhujal Scheme'| translate}}" (onChange)="onSelectAtalScheme()"
                        optionLabel="label" [showClear]="false"></p-dropdown>
                    <div *ngIf="isSubmitted && insertStatusFormControls.abyUser.errors" class="invalid-feedback">
                        <div *ngIf="insertStatusFormControls.abyUser.errors.required">{{'ATAL_BHUJAL_IS_REQUIRED' |
                            translate}}
                        </div>
                    </div>
                </div>

                <div *ngIf="insertStatusFormControls.abyUser.value" class="field col-12 md:col-2">
                    <label htmlFor="component">{{'DISTRICT'| translate}}</label>
                    <p-dropdown [options]="districtList" appendTo="body" formControlName="district"
                        placeholder="{{'Select District'| translate}}" (onChange)="onSelectDistrict()"
                        optionLabel="District" [showClear]="false"></p-dropdown>
                    <div *ngIf="isSubmitted && insertStatusFormControls.district.errors" class="invalid-feedback">
                        <div *ngIf="insertStatusFormControls.district.errors.required">{{'DISTRICT_IS_REQUIRED' |
                            translate}}</div>
                    </div>
                </div>

                <div *ngIf="insertStatusFormControls.district.value" class="field col-12 md:col-2">
                    <label htmlFor="component">{{'BLOCK'| translate}}</label>
                    <p-dropdown [options]="blockList" appendTo="body" formControlName="block"
                        placeholder="{{'ALL'| translate}}" (onChange)="onSelectBlock()" optionLabel="Block"
                        [showClear]="false"></p-dropdown>
                    <div *ngIf="isSubmitted && insertStatusFormControls.block.errors" class="invalid-feedback">
                        <div *ngIf="insertStatusFormControls.block.errors.required">{{'BLOCK_IS_REQUIRED' | translate}}
                        </div>
                    </div>
                </div>

                <div *ngIf="insertStatusFormControls.block.value" class="field col-12 md:col-2">
                    <label htmlFor="component">{{'Village'| translate}}</label>
                    <p-dropdown [options]="villageList" appendTo="body" formControlName="village"
                        placeholder="{{'ALL'| translate}}" optionLabel="Village" [showClear]="false"></p-dropdown>
                    <div *ngIf="isSubmitted && insertStatusFormControls.block.errors" class="invalid-feedback">
                        <div *ngIf="insertStatusFormControls.block.errors.required">{{'BLOCK_IS_REQUIRED' | translate}}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-2">
                    <label htmlFor="component">{{'PROGRAMME_TYPE'| translate}}</label>
                    <p-dropdown [options]="programmeTypeList" appendTo="body" formControlName="programmeType"
                        placeholder="{{'Select Programme Type'| translate}}" optionLabel="name" optionValue="value"
                        [showClear]="false" (ngModelChange)="onSelectProg($event)"></p-dropdown>
                    <div *ngIf="isSubmitted && insertStatusFormControls.programmeType.errors" class="invalid-feedback">
                        <div *ngIf="insertStatusFormControls.programmeType.errors.required">
                            {{'PROGRAMME_TYPE_IS_REQUIRED' | translate}}</div>
                    </div>
                </div>

                <div class="field col-12 md:col-2">
                    <label htmlFor="component">{{'PROGRAMME_NAME'| translate}}</label>
                    <p-dropdown [options]="programmeList" appendTo="body" formControlName="programme"
                        placeholder="{{'Select Programme'| translate}}" optionLabel="Program_Name"
                        [showClear]="false"></p-dropdown>
                    <div *ngIf="isSubmitted && insertStatusFormControls.programme.errors" class="invalid-feedback">
                        <div *ngIf="insertStatusFormControls.programme.errors.required">{{'PROGRAMME_IS_REQUIRED' |
                            translate}}</div>
                    </div>
                </div>

                <div class="field col-12 md:col-2">
                    <label *ngIf="selectProgType != 'Pond'" htmlFor="area">{{'TARGET_AREA(IN_ACR)' | translate}}</label>
                    <label *ngIf="selectProgType == 'Pond'" htmlFor="area">{{'NO_OF_APPLICATIONS' | translate}}</label>
                    <input formControlName="area" pInputText id="area" type="number" min="0"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && insertStatusFormControls.area.errors }" />
                    <div *ngIf="isSubmitted && insertStatusFormControls.area.errors" class="invalid-feedback">
                        <div *ngIf="insertStatusFormControls.area.errors.required">{{'AREA_IS_REQUIRED' |
                            translate}}
                        </div>
                    </div>
                </div>

                <!-- <div class="field col-12 md:col-3">
                    <label htmlFor="amount">{{'AMOUNT' | translate}}</label>
                    <input formControlName="amount" pInputText id="amount" type="number" min="0"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && insertStatusFormControls.amount.errors }" />
                    <div *ngIf="isSubmitted && insertStatusFormControls.amount.errors" class="invalid-feedback">
                        <div *ngIf="insertStatusFormControls.amount.errors.required">{{'AMOUNT_IS_REQUIRED' |
                            translate}}
                        </div>
                    </div>
                </div> -->

                <!-- <div class="field col-12 md:col-2">
                    <label htmlFor="farmersToBeBenefitted">{{'FARMER_TO_BE_BENEFITTEDD' | translate}}</label>
                    <input formControlName="farmersToBeBenefitted" pInputText id="farmersToBeBenefitted" type="number" min="0"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && insertStatusFormControls.farmersToBeBenefitted.errors }" />
                    <div *ngIf="isSubmitted && insertStatusFormControls.farmersToBeBenefitted.errors" class="invalid-feedback">
                        <div *ngIf="insertStatusFormControls.farmersToBeBenefitted.errors.required">{{'FARMER_TO_BE_BENEFITTED_IS_REQUIRED' |
                            translate}}
                        </div>
                    </div>
                </div> -->

                <div class="field col-12 md:col-2">
                    <label htmlFor="block">{{'START_DATE' | translate}}</label>
                    <p-calendar appendTo="body" [showIcon]="true" [showButtonBar]="true" dateFormat="dd-mm-yy"
                        formControlName="fromDate" [minDate]="todayDate"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && insertStatusFormControls.fromDate.errors }"></p-calendar>
                    <div *ngIf="isSubmitted && insertStatusFormControls.fromDate.errors" class="invalid-feedback">
                        <div *ngIf="insertStatusFormControls.fromDate.errors.required">{{'START_DATE_IS_REQUIRED' |
                            translate}}
                        </div>
                    </div>
                </div>

                <div *ngIf="insertStatusForm.value['fromDate']" class="field col-12 md:col-2">
                    <label htmlFor="block">{{'END_DATE' | translate}}</label>
                    <p-calendar appendTo="body" [showIcon]="true" [showButtonBar]="true" dateFormat="dd-mm-yy"
                        formControlName="endDate" [minDate]="insertStatusFormControls.fromDate.value"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && insertStatusFormControls.endDate.errors }"></p-calendar>
                    <div *ngIf="isSubmitted && insertStatusFormControls.endDate.errors" class="invalid-feedback">
                        <div *ngIf="insertStatusFormControls.endDate.errors.required">{{'END_DATE_IS_REQUIRED' |
                            translate}}
                        </div>
                        <div *ngIf="insertStatusForm.errors?.dateRangeInvalid && isSubmitted" class="invalid-feedback">
                            {{ 'START_DATE_MUST_BE_BEFORE_END_DATE' | translate }}
                        </div>
                    </div>
                </div>

                <!-- <div class="field col-12 md:col-4">
                    <label htmlFor="block">{{'CASTE' | translate}}</label>
                    <div class="caste-block">
                      <div class="field">
                        <div class="field-radiobutton mb-0">
                          <p-radioButton formControlName="caste" value="1"
                            id="IsSubsidyAvailabeYes"></p-radioButton>
                          <label for="IsSubsidyAvailabeYes">{{'GEN' | translate}}</label>
                        </div>
                      </div>
                      <div class="field mx-2">
                        <div class="field-radiobutton mb-0">
                          <p-radioButton formControlName="caste" value="2"
                            id="IsSubsidyAvailabeYes"></p-radioButton>
                          <label for="IsSubsidyAvailabeYes">{{'BC' | translate}}</label>
                        </div>
                      </div>
                      <div class="field">
                        <div class="field-radiobutton mb-0">
                          <p-radioButton formControlName="caste" value="3"
                            id="IsSubsidyAvailabeNo"></p-radioButton>
                          <label for="IsSubsidyAvailabeNo">{{'SC/ST' | translate}}</label>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="isSubmitted && insertStatusFormControls.caste.errors" class="invalid-feedback">
                        <div *ngIf="insertStatusFormControls.caste.errors.required">{{'CASTE_IS_REQUIRED' |
                            translate}}
                        </div>
                    </div>
                </div> -->

                <!-- <div class="field col-12 md:col-4">
                    <label htmlFor="block">{{'IS_ABY_USER' | translate}}</label>
                    <div class="caste-block">
                      <div class="field">
                        <div class="field-radiobutton mb-0">
                          <p-radioButton formControlName="abyUser" value="1"
                            id="IsSubsidyAvailabeYes"></p-radioButton>
                          <label for="IsSubsidyAvailabeYes">{{'Yes' | translate}}</label>
                        </div>
                      </div>
                      <div class="field mx-2">
                        <div class="field-radiobutton mb-0">
                          <p-radioButton formControlName="abyUser" value="2"
                            id="IsSubsidyAvailabeYes"></p-radioButton>
                          <label for="IsSubsidyAvailabeYes">{{'No' | translate}}</label>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="isSubmitted && insertStatusFormControls.abyUser.errors" class="invalid-feedback">
                        <div *ngIf="insertStatusFormControls.abyUser.errors.required">{{'IS_ABY_IS_REQUIRED' |
                            translate}}
                        </div>
                    </div>
                </div> -->
            </div>
        </form>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{'CANCEL' | translate}}" icon="pi pi-times" class="p-button-text"
            (click)="hideDialog()"></button>
        <button pButton pRipple label="{{'SAVE'| translate}}" icon="pi pi-check" class="p-button-text"
            (click)="saveProduct()"></button>
    </ng-template>
</p-dialog>

<!-- <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog> -->

<p-confirmDialog>
    <ng-template pTemplate="message" let-message>
        <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
            <i class="pi pi-exclamation-circle text-6xl text-primary-500"></i>
            <p>{{ message.message }}</p>
        </div>
    </ng-template>
</p-confirmDialog>